import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Paper.scss';

class Paper extends Component {
  render() {
    return (
      <div className="paper">
        {this.props.title ? <h3>{this.props.title}</h3> : null}
        {this.props.children}
      </div>
    );
  }
}

export default withStyles(s)(Paper);



// WEBPACK FOOTER //
// src/components/Paper/Paper.js